/** Public social profile URLs (footer). Env vars override these at build time. */
export const SITE_SOCIAL_LINKS = {
    facebook: "https://www.facebook.com/profile.php?id=61562830956867",
    instagram: "https://www.instagram.com/puzzle_interact/",
    youtube: "https://www.youtube.com/@puzzleinteract",
    appStore: "https://apps.apple.com/ca/app/sliding-puzzle-quest/id6782038654",
};

/**
 * @param {string|undefined} envValue REACT_APP_* value from process.env
 * @param {string} fallback from SITE_SOCIAL_LINKS
 * @returns {string} trimmed URL, or "" if both empty
 */
export function resolveSiteSocialUrl(envValue, fallback) {
    const fromEnv = (envValue || "").trim();
    if (fromEnv) return fromEnv;
    return (fallback || "").trim();
}
